module.exports = __webpack_public_path__ + "img/autorizationEN.10321823.png";